import { Link } from "wouter";
import {
  Container,
  SimpleGrid,
  Card,
  Group,
  Stack,
  Text,
  Title,
  ThemeIcon,
} from "@mantine/core";
import {
  IconUserStar,
  IconBuildingFactory,
  IconServerCog,
  IconCertificate,
  IconFileImport,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function AdminDashboard() {
  const { t } = useTranslation("common");

  const adminLinks = [
    {
      label: t("nav.users"),
      description: t("admin.dashboard.usersDescription"),
      icon: IconUserStar,
      href: "/admin/users",
      color: "blue",
    },
    {
      label: t("nav.tenants"),
      description: t("admin.dashboard.tenantsDescription"),
      icon: IconBuildingFactory,
      href: "/tenants",
      color: "violet",
    },
    {
      label: t("nav.jobs"),
      description: t("admin.dashboard.jobsDescription"),
      icon: IconServerCog,
      href: "/admin/jobs",
      color: "orange",
    },
    {
      label: t("nav.standards"),
      description: t("admin.dashboard.standardsDescription"),
      icon: IconCertificate,
      href: "/admin/standards",
      color: "teal",
    },
    {
      label: t("admin.portability.title"),
      description: t("admin.dashboard.portabilityDescription"),
      icon: IconFileImport,
      href: "/admin/schema-portability",
      color: "grape",
    },
  ];

  return (
    <Container size="lg" py="xl">
      <Title order={2} mb="lg">{t("nav.admin")}</Title>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {adminLinks.map((item) => (
          <Card
            key={item.href}
            component={Link}
            href={item.href}
            withBorder
            padding="lg"
            style={{ cursor: "pointer" }}
          >
            <Group>
              <ThemeIcon size="lg" variant="light" color={item.color}>
                <item.icon size={20} />
              </ThemeIcon>
              <Stack gap={2}>
                <Text fw={500}>{item.label}</Text>
                <Text size="sm" c="dimmed">{item.description}</Text>
              </Stack>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
}
